/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {NoteId, NoteInput} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getEditLeadNoteUrl = (id: string, noteId: NoteId) => {
  return `/api/v1/sales/leads/${id}/notes/${noteId}`;
};

/**
 * @summary Edit lead note
 */
export const editLeadNote = async (
  id: string,
  noteId: NoteId,
  noteInput: NoteInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getEditLeadNoteUrl(id, noteId), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(noteInput),
  });
};

export const getRemoveLeadNoteUrl = (id: string, noteId: NoteId) => {
  return `/api/v1/sales/leads/${id}/notes/${noteId}`;
};

/**
 * @summary Remove lead note
 */
export const removeLeadNote = async (
  id: string,
  noteId: NoteId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveLeadNoteUrl(id, noteId), {
    ...options,
    method: "DELETE",
  });
};

export const getAddLeadNoteUrl = (id: string) => {
  return `/api/v1/sales/leads/${id}/notes`;
};

/**
 * @summary Add lead note
 */
export const addLeadNote = async (
  id: string,
  noteInput: NoteInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<NoteId> => {
  return customFetch<NoteId>(getAddLeadNoteUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(noteInput),
  });
};
